import * as R from 'ramda';
import { createActions, handleActions } from 'redux-actions';

export const { openModal, closeCurrentModal } = createActions(
  'OPEN_MODAL',
  'CLOSE_CURRENT_MODAL',
);

export const defaultState = { name: '', payload: {} };

export const modalReducer = handleActions(
  {
    [openModal]: (_, { payload }) => payload,
    [closeCurrentModal]: R.always(defaultState),
  },
  defaultState,
);



// WEBPACK FOOTER //
// ./src/modals/modal-reducer.js